
const BlogGrid = () => {
  const posts = [
    {
      title: "Top 5 Markets for E-Commerce Expansion in 2025",
      excerpt: "Discover the most promising US markets for online businesses, including market size, competition levels, and entry strategies.",
      category: "Market Research",
      date: "December 12, 2024",
      readTime: "8 min read",
      image: "https://public.readdy.ai/ai/img_res/139624e3166c86c120aa8e24123eccf0.jpg",
      author: "Dickie Paterson"
    },
    {
      title: "Navigating US Shipping and Fulfillment",
      excerpt: "A comprehensive guide to domestic shipping, fulfillment centers, and logistics optimization across major US markets.",
      category: "Logistics",
      date: "December 10, 2024",
      readTime: "12 min read",
      image: "https://readdy.ai/api/search-image?query=US%20shipping%20and%20logistics%20operations%20with%20fulfillment%20centers%20and%20domestic%20trade%20routes%2C%20shipping%20optimization%20visualization%2C%20modern%20logistics%20industry&width=400&height=250&seq=blog-shipping&orientation=landscape",
      author: "Jessica Hanson"
    },
    {
      title: "Payment Solutions for US E-Commerce Success",
      excerpt: "Compare payment gateways, understand processing fees, and optimize checkout flows for American customers.",
      category: "Technology",
      date: "December 8, 2024",
      readTime: "6 min read",
      image: "https://readdy.ai/api/search-image?query=Digital%20payment%20systems%20and%20US%20e-commerce%20technology%2C%20payment%20gateways%20and%20financial%20technology%2C%20modern%20fintech%20solutions&width=400&height=250&seq=blog-payments&orientation=landscape",
      author: "Dickie Paterson"
    },
    {
      title: "Local SEO: Dominating Your City's Search Results",
      excerpt: "Learn how to optimize your local presence and rank #1 for location-based searches in your target markets.",
      category: "SEO Strategy",
      date: "December 5, 2024",
      readTime: "10 min read",
      image: "https://readdy.ai/api/search-image?query=Local%20SEO%20and%20search%20engine%20optimization%20visualization%2C%20Google%20Maps%20rankings%20and%20local%20business%20search%20results%2C%20modern%20digital%20marketing&width=400&height=250&seq=blog-seo&orientation=landscape",
      author: "Dickie Paterson"
    },
    {
      title: "Building Trust with US Online Customers",
      excerpt: "Strategies for establishing credibility and trust when selling to customers across different US regions.",
      category: "Customer Experience",
      date: "December 3, 2024",
      readTime: "7 min read",
      image: "https://readdy.ai/api/search-image?query=US%20customer%20trust%20and%20domestic%20business%20relationships%2C%20diverse%20American%20customers%20and%20e-commerce%20trust%20building%2C%20modern%20customer%20service%20excellence&width=400&height=250&seq=blog-trust&orientation=landscape",
      author: "Jessica Hanson"
    },
    {
      title: "E-Commerce Tax Compliance Across US States",
      excerpt: "Understanding sales tax obligations when selling across state lines, with practical compliance tips for growing businesses.",
      category: "Legal & Compliance",
      date: "November 30, 2024",
      readTime: "15 min read",
      image: "https://readdy.ai/api/search-image?query=US%20tax%20compliance%20and%20business%20legal%20documentation%2C%20state%20tax%20regulations%20and%20financial%20compliance%2C%20professional%20business%20legal%20environment&width=400&height=250&seq=blog-tax&orientation=landscape",
      author: "Jessica Hanson"
    }
  ];

  const categories = ["All", "SEO Strategy", "Market Research", "Technology", "Logistics", "Legal & Compliance", "Customer Experience"];

  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Latest Articles & Insights
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Stay updated with the latest trends, strategies, and best practices 
            for dominating US e-commerce markets and online rankings.
          </p>
        </div>

        {/* Category Filter */}
        <div className="flex flex-wrap justify-center gap-2 mb-12">
          {categories.map((category, index) => (
            <button 
              key={index}
              className={`px-4 py-2 rounded-full text-sm font-medium transition-colors whitespace-nowrap ${
                index === 0 
                  ? 'bg-indigo-600 text-white' 
                  : 'bg-white text-gray-600 hover:bg-gray-100'
              }`}
            >
              {category}
            </button>
          ))}
        </div>

        {/* Blog Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {posts.map((post, index) => (
            <article key={index} className="bg-white rounded-lg overflow-hidden shadow-sm hover:shadow-lg transition-shadow cursor-pointer">
              <img 
                src={post.image}
                alt={post.title}
                className="w-full h-48 object-cover"
              />
              
              <div className="p-6">
                <div className="flex items-center justify-between mb-3">
                  <span className="text-indigo-600 text-sm font-medium">{post.category}</span>
                  <span className="text-gray-500 text-sm">{post.readTime}</span>
                </div>
                
                <h3 className="text-xl font-bold text-gray-900 mb-3 line-clamp-2">
                  {post.title}
                </h3>
                
                <p className="text-gray-600 mb-4 line-clamp-3">
                  {post.excerpt}
                </p>
                
                <div className="flex items-center justify-between">
                  <div className="text-sm text-gray-500">
                    <span>{post.author}</span>
                    <span className="mx-2">•</span>
                    <span>{post.date}</span>
                  </div>
                  
                  <button className="text-indigo-600 hover:text-indigo-700 text-sm font-semibold whitespace-nowrap">
                    Read More →
                  </button>
                </div>
              </div>
            </article>
          ))}
        </div>

        {/* Load More */}
        <div className="text-center mt-12">
          <button className="bg-indigo-600 hover:bg-indigo-700 text-white px-8 py-3 rounded-lg font-semibold transition-colors whitespace-nowrap">
            Load More Articles
          </button>
        </div>
      </div>
    </section>
  );
};

export default BlogGrid;
